<template>
  <v-btn
    class="mx-2"
    :class="state.class"
    depressed
    rounded
    small
  >
    {{ state.name }}
  </v-btn>
</template>

<script>
  export default {
    props: ['isActive'],
    computed: {
      state(){
        if(this.isActive == 1){
          return  {name: "Active", class: "success white--text"}
        } else if(this.isActive == 2){
          return {name: "To be updated", class: "warning white--text"}
        } else {
          return { name: "Inactive", class: "error white--text"}
        }
      }
    }
  }
</script>